// import {ASSETS_ROOT} from './../../../../../@polygonjs/polygonjs/src/core/loader/AssetsUtils';
// import {Example} from '../../Example';
import type {ExampleData, DataCallbackOptions} from '../../Common';
import {addPerspectiveCameraOBJWithOrbitControls} from '../../ExampleUtils';
// import {ExpressionType} from './../../../../../@polygonjs/polygonjs/src/engine/expressions/methods/Common';
export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();
	const geo = root.createNode('geo');

	const box = geo.createNode('box');
	const torus = geo.createNode('torus');
	const transform = geo.createNode('transform');
	const noise = geo.createNode('noise');
	const merge = geo.createNode('merge');

	noise.setInput(0, torus);
	transform.setInput(0, box);
	merge.setInput(0, noise);
	merge.setInput(1, transform);
	merge.flags.display.set(true);

	torus.p.radiusTube.set(0.1);
	torus.p.segmentsRadial.set(10);
	torus.p.segmentsTube.set(30);

	noise.p.amplitude.set(0.7);
	noise.p.freq.set([0.3, 0.3, 0.3]);
	noise.p.offset.y.set('$T');

	box.p.size.set(0.25);

	transform.p.t.x.set(`centroid('../${noise.name()}').x`);
	transform.p.t.z.set(`centroid('../${noise.name()}').z`);

	noise.uiData.setComment(
		`The torus is deformed with a noise SOP, and the box is maintained in its center with the centroid expression`
	);

	// add a light
	root.createNode('hemisphereLight');

	const {perspectiveCamera1} = addPerspectiveCameraOBJWithOrbitControls(root);

	// play
	scene.play();

	// EXPORT
	// const nodes = [torus];
	// const htmlNodes = {box};
	// const camera = perspectiveCamera1;
	// return {scene, camera, nodes, htmlNodes};
	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [torus],
		autoLayout: true,
	};
}

// export const expressionCentroid = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_CATEGORY}/${ExamplePrefix.USING_EXPRESSIONS}/centroid`,
// 		createData,
// 		relatedExpressions: [ExpressionType.centroid],
// 	}),
// ];
